// @ts-nocheck
import loadStoreLists from "@store/Framework/Store/Pages/StoreLists/Handlers/LoadStoreLists";
import { deleteStoreListApi } from "@store/Services/StoreListService";
import {
    createHandlerChainRunner,
    Handler,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler<
    {
        storeListId: string;
        onSuccess?: () => void;
    },
    {
        error: boolean;
    }
>;

export const DispatchBeginDeleteStoreLists: HandlerType = props => {
    props.dispatch({
        type: "Pages/StoreLists/BeginDeleteStoreList",
    });
};

export const RequestRemoveStorelist: HandlerType = props => {
    return deleteStoreListApi({ storeListId: props.parameter.storeListId }).then(() => {
        props.error = false;
    });
};

export const ResetStoreListsData: HandlerType = props => {
    props.dispatch({
        type: "Data/StoreLists/Reset",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.error) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.();
    }
};

export const DispatchCompleteDeleteStoreList: HandlerType = props => {
    props.dispatch({
        type: "Pages/StoreLists/CompleteDeleteStoreList",
    });
};

export const DispatchLoadStoreLists: HandlerType = props => {
    props.dispatch(loadStoreLists());
};

export const chain = [
    DispatchBeginDeleteStoreLists,
    RequestRemoveStorelist,
    ResetStoreListsData,
    ExecuteOnSuccessCallback,
    DispatchCompleteDeleteStoreList,
    DispatchLoadStoreLists,
];

const deleteStoreList = createHandlerChainRunner(chain, "DeleteStoreList");
export default deleteStoreList;
